import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const PNEUMOLOGY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.diagnoses,
  },
  {
    key: "admission_reason",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.admissionReason,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.therapy,
  },
  {
    key: "discharge_summary",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.dischargeSummary,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.recommendations,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .dischargeMedications,
  },
  {
    key: "concluding_remarks",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.concludingRemarks,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.anamnesis,
  },
  {
    key: "admission_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .admissionMedication,
  },
  {
    key: "clinical_examination",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .clinicalExamination,
  },
  {
    key: "parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.parameters,
  },
  {
    key: "prescribed_regulations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .prescribedRegulations,
  },
  {
    key: "next_provider",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames.nextProvider,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formFieldNames
        .additionalDiagnosticFindings,
  },
];

export function createPneumologyDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY
  >(props, PNEUMOLOGY_FIELD_CONFIG);
}
